import * as React from 'react';
export const cancelSvg = React.forwardRef(function cancelSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.256 1.256a.875.875 0 0 1 1.238 0L8 6.763l5.506-5.507a.875.875 0 1 1 1.238 1.238L9.237 8l5.507 5.506a.875.875 0 1 1-1.238 1.238L8 9.237l-5.506 5.507a.875.875 0 0 1-1.238-1.238L6.763 8 1.256 2.494a.875.875 0 0 1 0-1.238Z',
    }),
  );
});
cancelSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cancel = {
  category: 'icon',
  colorable: true,
  name: 'cancel',
  svg: cancelSvg,
};
